<template>
  <div id="multipleselect">
    <div class="functional-select-wrapper" v-on:click.stop="multipleFocus()">
      <label class="display-container multiple-select-container clearfix" v-bind:class="(show)?'single-selected-focus':''">
        <p v-show="multiple.selectedList.length == 0 ">
          <span v-if="originOptions.length != 0 ">Please choose</span>
          <span v-else>no options</span>
        </p>
        <p class="multiple-selected-item" v-for="item in new_selectedList" track-by="$index">
          <!-- multiple.selectedList 后台传来的默认已选-->
          {{ item.name }}
          <i v-on:click.stop.prevent="multipleRemove(item.id)">×</i>
        </p>
        <i class="drop" v-bind:class="(show)?'drop-up':''">▼</i>
      </label>
      <div class="options-container" v-show="show">
        <div class="search-container">
          <input placeholder="search here" class="search-input" v-model="search" v-on:keyup="multipleSearch($event)"
            v-on:click.stop />
        </div>
        <ul class="options-ul-list">
          <li v-show="displayOptions.length == 0">no data queryed</li>
          <li v-for="item in displayOptions" v-on:click.stop.prevent="multipleSelect(item.id)" v-bind:class=" selectedIdList.indexOf(item.id)!=-1?'selected':'' ">
            {{ item.name }}
          </li>
        </ul>
      </div>
      <div v-if="multiple.selectedList && multiple.selectedList.length > 0" v-for="(ele,i) in multiple.selectedList"
        :key=ele.id>

        <bus_line_info ref="infos" :line_name=ele.name :rate=ele.rate :format_code=ele.format_code>
        </bus_line_info>

      </div>

    </div>
  </div>
</template>

<script>
  import _global from './global.vue'
  import axios from 'axios'
  import bus_line_info from "./bus_line_info.vue";
  export default {
    name: 'multipleselect',
    data() {
      return {
        originOptions: [],
        displayOptions: [],
        show: false,
        search: '',
        selectedList: [],
        new_selectedList: [],
        selectedIdList: [],
        busLineRank: 1,
        multiple: {
          originOptions: [],
          selectedList: [],
        },

      }
    },

    components: {
      bus_line_info
    },
    watch: {
      originOptions: function(val, oldVal) {
        this.show = false;
        this.multiple.originOptions = val;
      },
      selecteddata: function(val, oldVal) {
        this.multiple.selectedList = val;
        this.selectedIdList = [];
        for (var i = 0; i < this.multiple.selectedList.length; i++) {
          var item = this.multiple.selectedList[i];
          this.selectedIdList.push(item.id);
        }
      },
      selectedList: function(val, oldVal) {
        this.new_selectedList = this.transFormat(val)
      }
    },
    created() {
    },
    mounted() {
      this.getBusLineData();
    },
    computed: {},
    ready: function() {
      window.addEventListener('click', this.blur)
    },
    methods: {
      transFormat(val) {
        let length_val = val.length;
        let new_selectedList = [];
        let index = 0;
        if (length_val > 0) {
          let obj = {};
          for (let ele in val) {
            if (val[ele].id != null) {
              obj.id = val[ele].id;
              obj.name = val[ele].name;
              obj.rate = val[ele].rate;
              obj.format_code = val[ele].format_code;
              new_selectedList.push(obj);
              if (ele > 3) {
                new_selectedList[3] = new Object();
                new_selectedList[3].name = "+" + String(index);
                index = index + 1;
              }
            } else {

            }
          }
        }
        return new_selectedList;
      },
      queryData: function() {
        var mySelf = this
        //do ajax here
        var bus_line = JSON.parse(sessionStorage.getItem('Bus_Line'));
        // 多选
        var norm_bus_line = this.formatOriginOptions(bus_line);
        mySelf.multiple.originOptions = this.formatOriginOptions(bus_line); //附初值
        if (norm_bus_line.length > 10) {
          //挑前十个
          mySelf.multiple.selectedList = norm_bus_line.slice(0, 10);
        } else {
          mySelf.multiple.selectedList = norm_bus_line;
        }
        //把默认已选转成+x形式

        var selectedIdList = [];
        this.originOptions = mySelf.multiple.originOptions;
        this.displayOptions = mySelf.multiple.selectedList;
        for (let ele in this.displayOptions) {
          selectedIdList.push(this.displayOptions[ele].id);
        }

        mySelf.selectedIdList = selectedIdList;
        this.new_selectedList = this.transFormat(mySelf.multiple.selectedList);

      },
      formatOriginOptions: function(bus_line) {

        var bus_lines = [];
        for (let ele in bus_line) {
          var norm_bus_line = {
            "id": 0,
            "name": "default",
            "rate": "default",
            "format_code": [0],
          };
          norm_bus_line.id = bus_line[ele].bus_id;
          norm_bus_line.name = bus_line[ele].bus_name;
          norm_bus_line.rate = this.toPercent(bus_line[ele].value_rating);
          norm_bus_line.format_code = bus_line[ele].format_code;
          bus_lines.push(norm_bus_line);
        }
        return bus_lines;
      },
      toPercent: function(point) {
        var str = Number(point * 100).toFixed(0);
        str += "%";
        return str;
      },
      getBusLineData: function() {
        let data = JSON.parse(sessionStorage.getItem('Data_Information'));
        let api_url = 'http://' + _global.serverSrc + '/bus_line_rating/?format=json';
        var _self = this;
        delete data.media_format_options;
        let arr = [];
        Object.keys(data).forEach(v => {
          let o = {};
          o[v] = data[v];
          arr.push(o);
        })
        let obj = {
          'email': JSON.parse(sessionStorage.getItem('User')),
          'dataInfo': arr
        }
        this.$axios.post(api_url, obj)
          .then(function(response) {
            if (response.data) {
              _self.busLineRank = response.data.bus_line_rating;
              sessionStorage.setItem('Bus_Line', JSON.stringify(response.data.bus_line_rating));
              _self.queryData();
            }
          })
          .catch(e => {
          })


      },
      multipleFocus: function() {
        if (!this.show) {
          document.body.click();
          this.show = true;
          this.multipleSearch();
          this.searchInputFocus();
        } else {
          this.blur();
        }
      },
      searchInputFocus: function() {
        var searchInput = this.$el.getElementsByClassName('search-input')[0];

        this.$nextTick(function() {
          searchInput.focus();
        })

      },


      updateself: function() {
        this.$forceUpdate();
      },
      multipleSelect: function(id) {
        var mySelf = this;
        var displayOptions = mySelf.originOptions;
        var selectedList = mySelf.selectedList;

        var selectedIdList = mySelf.selectedIdList;
        //在原始数组里找 找到后1.添加到selectedList
        //若selectedIdList存在 则删除
        if (selectedIdList.indexOf(id) != -1) {
          mySelf.multipleRemove(id);
          return;
        }

        for (var i = 0; i < displayOptions.length; i++) {
          var item = displayOptions[i]
          if (item.id == id) {
            selectedList.push(item);
            selectedIdList.push(id);
            mySelf.multipleInitSearch();
            mySelf.multipleSearch();
            mySelf.dispatchData();
            mySelf.searchInputFocus();
          }
        }

      },
      dispatchData: function() {
        //this.$dispatch('selected', this.selectedList);
      },
      multipleRemove: function(id) {
        var mySelf = this;
        var selectedList = mySelf.multiple.selectedList;
        var selectedIdList = mySelf.selectedIdList;
        for (var i = 0; i < selectedList.length; i++) {
          var item = selectedList[i]
          if (item.id == id) {
            //1.从selectedList中删除 2.从selectedIdList中删除
            selectedList.splice(i, 1);
            //更改new_selected
            //mySelf.new_selectedList = this.transFormat(selectedList)
            var index = selectedIdList.indexOf(item.id)
            selectedIdList.splice(index, 1)
            mySelf.multipleInitSearch();
            mySelf.multipleSearch();
            mySelf.dispatchData();
            mySelf.searchInputFocus();
            return;
          }
        }
      },
      multipleSearch: function(event) {
        var mySelf = this;
        var search = mySelf.search;
        var REG_RULE = new RegExp(search, "i") //根据用户输入值做正则
        //inputDom.style.width = (search.length*0.6) + 'em'

        var originOptions = mySelf.originOptions;
        var displayOptions = mySelf.displayOptions;

        // 通过回车键 添加
        if (event && event.keyCode == 13 && search != '') {

          for (var i = 0; i < originOptions.length; i++) {
            var item = originOptions[i]
            if (item.name == search) {
              mySelf.multipleSelect(item.id);
              return;
            } else if (i == (originOptions.length - 1)) {
              alert('不存在的选项！');
              return;
            }
          }
        }

        //将展示列表置空 然后用正则去原始列表中匹配
        mySelf.displayOptions = [];
        //正则表达 匹配搜索字符
        for (var i = 0; i < originOptions.length; i++) {
          var item = originOptions[i]
          if (REG_RULE.test(item.name)) {
            mySelf.displayOptions.push(item)
          }
        }
      },
      multipleInitSearch: function() {
        var mySelf = this;
        //重置搜索框 1.清空搜索数据 2.下拉框展示全量
        mySelf.search = '';
      },
      blur: function() {
        this.show = false;
        this.search = '';
      }

    },
  }
</script>

<style>
</style>
